// extracted by mini-css-extract-plugin
module.exports = {"input":"CustomOccasionInput_input__Z_sdk"};